import React from "react";

const data = [
  {
    id: "ContourSegmentationPanel",
    title: "New Contour Segmentation Panel and Tool Integration",
    summary: () => (
      <p>
        We're introducing a dedicated contour segmentation panel with UI/UX updates 
        to distinguish contour tools from labelmap tools. This panel will provide 
        direct access to contour-specific actions, with a tab or context-based 
        display to ensure the right tools appear for the selected segmentation type.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          In this release, the OHIF Viewer will gain a purpose-built contour 
          segmentation panel. The panel will make it clear when users are working 
          with contour-based segmentations versus labelmaps, offering an organized 
          location for all contour tools. The segmentation panel will allow switching 
          between labelmap and contour modes via tabs, or it will automatically show 
          the relevant toolset based on the active segmentation. This structure will 
          simplify creation of new contours and make workflows more intuitive by 
          reducing tool clutter and ambiguity.
        </p>
      </div>
    )
  },
  {
    id: "ExpandedContourEditingTools",
    title: "Expanded Contour Editing Tools",
    summary: () => (
      <p>
        We're adding new tools for contour creation and refinement, including 
        spline-based segmentation, freehand drawing, livewire segmentation, and 
        a new sculpture-style edit tool for precise adjustments.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          This update expands the available toolset for contour segmentation, giving 
          users more flexibility in how they create and refine structures. The spline 
          segmentation tool will allow smooth, adjustable curve creation, while 
          freehand and livewire segmentation will support rapid and intuitive tracing. 
          A new sculpture-style edit tool will let users push, pull, and reshape 
          contours directly, enabling fine-tuned adjustments without needing to redraw 
          entire structures. Together, these tools provide a more versatile and 
          efficient contour editing experience.
        </p>
      </div>
    )
  },
  {
    id: "ContourAPICleanup",
    title: "Contour API for Cleanup and Optimization",
    summary: () => (
      <p>
        A new Contour API will enable programmatic cleanup and optimization of 
        segmentation data, with functions for point simplification, smoothing, 
        merging, and removing unwanted geometry.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          To support advanced contour workflows, we're introducing an API with 
          built-in operations for contour optimization. Developers will be able to 
          decimate contours to reduce point counts without losing shape integrity, 
          smooth jagged edges, and merge adjacent "islands" into unified segments. 
          The API will also allow removal of unwanted geometry, such as small 
          isolated contours or holes within structures. These tools make it easier 
          to keep contour datasets clean, efficient, and analysis-ready.
        </p>
      </div>
    )
  },
  {
    id: "LogicalOperationsContours",
    title: "Logical Operations on Contours",
    summary: () => (
      <p>
        We will add logical operations to create new contours from existing ones, 
        including add, remove, duplicate, and hole-based segmentation creation.
      </p>
    ),
    description: () => (
      <div className="flex flex-col space-y-5">
        <p>
          Logical contour operations will allow users to combine and manipulate 
          existing contours to produce new segmentations. These include adding or 
          subtracting shapes, duplicating structures for modification, and generating 
          a new segment from an existing contour hole. This capability will streamline 
          complex editing workflows, reduce repetitive drawing, and support advanced 
          segmentation scenarios where structures overlap or require composite shapes.
        </p>
      </div>
    )
  }
];

export default data;